import React from 'react'
import { Grid, Icon, Popup } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import Labels from './../../../../common/Labels'
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Access Control Card');
    }
})
class SummaryViewContentAccessControl extends React.Component {

    openCategoryModal = (e, type, page) => {
        this.props.handleModalKB(true, type, page)
    }
    render() {
        const checkAccess = this.props.selectedPracticeLibrary.participants && this.props.selectedPracticeLibrary.participants.length
            && this.props.selectedPracticeLibrary.participants.filter((participant) => { return participant.role === "author" && participant.accountUserId === this.props.user._id });

        return (
            <div >
                <div className="float-left pad_10  w_100" style={{ margin: "0 0 10px 0", background: "white" }}>
                    <div className="float-left w_100" style={{ margin: "0 0 5px 0" }} >
                        <div className="float-left" style={{ fontFamily: "montserrat-semibold", color: "#9e9e9e" }}>Publish level</div>
                        {this.props.selectedPracticeLibrary.status !== 0 || this.props.selectedPracticeLibrary.scope === "Private" || (checkAccess.length === 0 && this.props.selectedOrganisation.role !== 'workspaceOwner') ?
                            null :
                            <div
                                className="float-right clr-blue cursor-pointer"
                                onClick={(e) => this.openCategoryModal(e, "scope", "content")}>
                                {this.props.scope === "Private" ?
                                    <span>Change to Public Library</span> :
                                    null
                                    // <span>Change to Workspace Library</span>
                                }
                            </div>
                        }
                    </div>
                    {this.props.scope === "Private" ?
                        <div className="float-left w_100">
                            <b>Workspace Library</b><br />
                            <p className="f_11">Content will appear under Workspace Library after it is published. All workspace level users can view this content.</p>
                        </div> :
                        <div className="float-left w_100">
                            <b>Public Library</b><br />
                            <p className="f_11">Content appear in Public Library. All platform users can view this content.</p>
                        </div>}
                </div>
            </div>
        )
    }
}

export default SummaryViewContentAccessControl